export default __webpack_public_path__ + "static/media/bag.6e13aca8.png";